export default __webpack_public_path__ + "static/media/socketio.31eed582.jpg";